// Pure, framework-agnostic text-splitting for client-side ordstöd marking.
// Mirrors splitTextNode in rehype-ordstod.ts (the server-side MDX pass) but
// operates on a plain string and returns plain-object segments instead of
// hast nodes — InlineMath.tsx turns "ord" segments into <span data-ordstod>.
// Kept separate from InlineMath so the matching logic is unit-testable
// without React.
import { matchText } from "./match";

export interface MarkedSegment {
  kind: "text" | "ord";
  value: string;
  lemma?: string; // present when kind === "ord"
}

export function markTextSegments(
  text: string,
  formIndex: Map<string, string>,
): MarkedSegment[] {
  const traffar = matchText(text, formIndex);
  if (traffar.length === 0) return [{ kind: "text", value: text }];
  const out: MarkedSegment[] = [];
  let cursor = 0;
  for (const t of traffar) {
    if (t.start > cursor) out.push({ kind: "text", value: text.slice(cursor, t.start) });
    out.push({ kind: "ord", value: text.slice(t.start, t.end), lemma: t.lemma });
    cursor = t.end;
  }
  if (cursor < text.length) out.push({ kind: "text", value: text.slice(cursor) });
  return out;
}
